import {FC} from 'react';
import {styled} from 'styled-components';

import {LoadingIndicator} from '@shared_web/components/core/loading_indicator';
import {Flex} from '@shared_web/components/core2/flex';

import {useNutriDb} from '@website_frontend/lib/data_stores';

export const HomePage: FC = () => {
  const nutriDb = useNutriDb();

  return (
    <Wrapper>
      {nutriDb && (
        <div>
          <h1>Nutri DB</h1>
          <p>{nutriDb.stats.totalFoods} foods</p>
        </div>
      )}
      {!nutriDb && (
        <Flex $align="center" $gap="s">
          <LoadingIndicator />
          <div>Loading DB...</div>
        </Flex>
      )}
    </Wrapper>
  );
};
HomePage.displayName = 'HomePage';

const Wrapper = styled.div`
  flex-grow: 1;
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: safe center;
  &:first-child {
    margin-top: auto;
  }
  &:last-child {
    margin-bottom: auto;
  }
`;
